import {
  FETCH_START,
  FETCH_SUCCESS,
  GLOBAL_FETCH_START,
  GLOBAL_FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  SIGNOUT_USER_SUCCESS,
  SUCCESSFUL_CODE
} from "appRedux/constants";
import { clearSession } from "appRedux/store/cookies";
import api from "appRedux/api";
import { handleError } from "appRedux/actions/Common";
import _ from "lodash";
import { SELECTED_OPERATORS } from "containers/BuyOperatorToken/actions/constants";

export const showAuthMessage = message => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  };
};

export const clearUser = () => {
  clearSession();
  return dispatch => {
    dispatch({ type: SIGNOUT_USER_SUCCESS });
  };
};

export const getUserWihToken = _token => {};

export const getMeWithToken = token => {
  return dispatch => {
    dispatch({ type: FETCH_START });
    const url = "/users/confirm";
    api
      .post(url, { token: token })
      .then(({ data }) => {
        /**
         * this need to be implemented
         */
        if (data.status && data.statusCode === SUCCESSFUL_CODE) {
          dispatch({ type: FETCH_SUCCESS, payload: true });
        } else {
          dispatch(
            handleError(
              _.isEmpty(data.message) ? "Network Error" : data.message
            )
          ); // same as "FETCH_ERROR"
        }
      })
      .catch(error => {
        dispatch(handleError(error.message)); // same as "FETCH_ERROR"
      });
  };
};

export const getUser = (
  _loginRequest = false,
  callbackNeeded = false,
  callback
) => {
  return dispatch => {
    dispatch({ type: GLOBAL_FETCH_START });
    const url = "/users/me";
    api
      .get(url)
      .then(({ data }) => {
        if (data.status && data.statusCode === SUCCESSFUL_CODE) {

          dispatch({ type: GLOBAL_FETCH_SUCCESS });

          callbackNeeded && callback({ status: "successful", data: data.data });
        } else {
          dispatch(
            handleError(
              _.isEmpty(data.message) ? "Network Error" : data.message
            )
          ); // same as "FETCH_ERROR"
          dispatch({ type: GLOBAL_FETCH_SUCCESS });
          callbackNeeded &&
            callback({ status: "error", data: null, message: data.message });
        }
      })
      .catch(error => {
        dispatch(handleError(error.message)); // same as "FETCH_ERROR"
        callbackNeeded &&
          callback({ status: "error", data: null, message: error.message });
        dispatch(userSignOut());
        dispatch({ type: GLOBAL_FETCH_SUCCESS });
      });
  };
};

export const userSignOut = () => {
  return dispatch => {
    dispatch({ type: SELECTED_OPERATORS, payload: [] });
    dispatch({ type: GLOBAL_FETCH_START });
    clearSession();
    dispatch({ type: FETCH_SUCCESS, payload: true });
    dispatch({ type: SIGNOUT_USER_SUCCESS });
    dispatch({ type: GLOBAL_FETCH_SUCCESS });
  };
};
